'use client'

import { MessageCircle } from 'lucide-react'
import Link from 'next/link'
import { motion } from 'framer-motion'

export default function WhatsAppButton() {
    const phoneNumber = '905331391444'
    const message = 'Merhaba, vize danışmanlığı hakkında bilgi almak istiyorum.'
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

    return (
        <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
            className="fixed bottom-6 right-6 z-50"
        >
            <Link
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20ba5a] transition-colors relative group"
                aria-label="WhatsApp üzerinden bizimle iletişime geçin"
            >
                <MessageCircle className="w-8 h-8" />

                {/* Tooltip */}
                <div className="absolute right-full mr-3 bg-white text-gray-800 px-3 py-1.5 rounded-lg shadow-md text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
                    WhatsApp Bilgi Hattı
                </div>

                {/* Pulse Effect */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping pointer-events-none"></span>
            </Link>
        </motion.div>
    )
}
